import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import type { Action, FieldValues } from '@/api/generated/model';
import { useNotification } from '@/contexts/NotificationContext';
import { useRunMatchAction, useRunTournamentAction } from '@/hooks/useManage';
import type { RunAction } from './ActionButton';

/** Действие сценария турнира: сообщение + переход по `redirect` из ActionResult. */
export const useTournamentActionRunner = (tournamentId: string): RunAction => {
  const navigate = useNavigate();
  const { showSuccess } = useNotification();
  const { mutateAsync } = useRunTournamentAction(tournamentId);

  return useCallback(
    async (action: Action, values?: FieldValues) => {
      const result = await mutateAsync({ actionId: action.id, values });
      if (result.message) showSuccess(result.message);
      if (result.redirect) navigate(result.redirect);
      return result;
    },
    [mutateAsync, navigate, showSuccess],
  );
};

export const useMatchActionRunner = (matchId: string, onDone?: (actionId: string) => void): RunAction => {
  const { mutateAsync } = useRunMatchAction(matchId);
  return useCallback(
    async (action: Action, values?: FieldValues) => {
      const match = await mutateAsync({ actionId: action.id, values });
      onDone?.(action.id);
      return match;
    },
    [mutateAsync, onDone],
  );
};
